import React from 'react';
import { Card, Container } from 'react-bootstrap';
import { getCryptoUnavailableHint, getLanHttpsUrl } from '../../polyfills/cryptoPolyfill';

const CryptoRequiredNotice = () => {
  const httpsUrl = getLanHttpsUrl();

  return (
    <Container className="py-5" style={{ maxWidth: 640 }}>
      <Card className="shadow-sm border-0">
        <Card.Body className="p-4">
          <h1 className="h4 mb-3" style={{ color: '#1c4220' }}>
            Contexto seguro necessário
          </h1>
          <p className="text-muted mb-3">{getCryptoUnavailableHint()}</p>
          <p className="mb-2">
            <strong>Para os colegas testarem na rede:</strong>
          </p>
          <ol className="text-muted small mb-3">
            <li>No projeto, use: <code>npm run start:lan</code></li>
            <li>Acesse por <strong>HTTPS</strong>, não HTTP</li>
            <li>No Azure AD, cadastre o redirect: <code>{httpsUrl}/home</code></li>
          </ol>
          {httpsUrl.startsWith('https://') && (
            <a className="btn btn-success btn-sm" href={`${httpsUrl}/`}>
              Tentar em HTTPS
            </a>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CryptoRequiredNotice;
